// src/api/walletApi.js
import apiClient from "./axios";

const walletApi = {
  getAll: (page = 1, pageSize = 10, search = "") =>
    apiClient.get("/wallets/", {
      params: { page, page_size: pageSize, search },
    }),

  creditWallet: (walletId, data) =>
    apiClient.post(`/wallets/${walletId}/credit/`, data),

  debitWallet: (walletId, data) =>
    apiClient.post(`/wallets/${walletId}/debit/`, data), // ← NEW
  
  // getHistory: (walletId, page = 1, pageSize = 10) =>
  //   apiClient.get(`/wallet-histories/`, { params: { wallet: walletId, page, page_size: pageSize } }),
  getHistory: (walletId = null, search = "", page = 1, pageSize = 10) => {
    const params = {
      page,
      page_size: pageSize,
    };

    if (walletId) params.wallet = walletId;
    if (search) params.search = search;

    return apiClient.get("/wallet-histories/", { params });
  },

  exportWallets: async () => {
    const response = await apiClient.get('/wallets/export/', {
      responseType: 'blob', // Critical for file download
    });
    return response.data; // Blob
  },

  exportHistory: async () => {
    const response = await apiClient.get('/wallet-histories/export/', {
      responseType: 'blob',
    });
    return response.data; // Blob
  },
};

export default walletApi;
